import {
  GET_HOME_IMAGES,
  GET_NEW_HOME_IMAGE,
  GET_DELETED_HOME_IMAGE,
  HOME_IMAGES_LOADING,
} from '../actions/types';

const initialState = {
  homeImages: null,
  homeImageloading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_HOME_IMAGES:
      return {
        ...state,
        homeImages: action.payload,
        homeImageloading: false,
      };
    case HOME_IMAGES_LOADING:
      return {
        ...state,
        homeImageloading: true,
      };
    case GET_NEW_HOME_IMAGE:
      return {
        ...state,
        homeImages: action.payload,
        homeImageloading: false,
      };
    case GET_DELETED_HOME_IMAGE:
      return {
        ...state,
        homeImages: action.payload,
        homeImageloading: false,
      };
    default:
      return state;
  }
}
